import React from 'react';
import styles from './GirlImage.module.css';

const GirlImage = () => {
  return <div className={styles.girlImage}></div>;
};

export default GirlImage;
